(function() {
    'use strict';

    angular.module('app.archivoBNCR', []);
})();
